<template>
  <el-main class="systemNotification" v-loading="loading">
    <div class="notification-list">
      <div
        class="notification-item"
        v-for="(item, index) in pagedNotificationList"
        :key="item.msgId || index"
      >
        <div class="title-time">
          <div class="title">{{ item.title }}</div>
          <div class="time">
            <span>{{ $t('operate.name90') }}</span>
            <span>{{ item.time }}</span>
          </div>
        </div>
        <div class="content">
          {{ item.content }}
        </div>
      </div>
      <div v-if="!loading && loadError" class="empty error">
        {{ $t('notification.loadError') }}
      </div>
      <div v-else-if="!loading && pagedNotificationList.length === 0" class="empty">
        <div>{{ $t('notification.empty') }}</div>
        <div class="empty-hint">{{ $t('notification.emptyHint') }}</div>
      </div>
    </div>

    <el-pagination
      v-if="total > 0"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </el-main>
</template>
<script>
import { findWebBcstMsgList } from '@/api/home.js'
import { formatSystemNotification } from '@/utils/systemNotificationLabels.js'

export default {
  data () {
    return {
      loading: false,
      loadError: false,
      queryInfo: {
        pageNumber: 1,
        pageSize: 10
      },
      total: 0,
      rawNotificationList: []
    }
  },
  computed: {
    // 依赖 $t，语言切换后自动重算标题与正文
    localizedNotificationList () {
      return this.rawNotificationList.map((item) => ({
        ...formatSystemNotification(this, item),
        msgId: item.msgId
      }))
    },
    pagedNotificationList () {
      const start = (this.queryInfo.pageNumber - 1) * this.queryInfo.pageSize
      return this.localizedNotificationList.slice(start, start + this.queryInfo.pageSize)
    }
  },
  mounted () {
    this.getNotificationList()
    this.$bus.$on('lang', this.handleLangChange)
  },
  beforeDestroy () {
    this.$bus.$off('lang', this.handleLangChange)
  },
  methods: {
    handleLangChange () {
      // 仅触发 computed 重算；列表仍限定后端 1 小时窗口，不重新拉取历史
    },
    getNotificationList () {
      this.loading = true
      this.loadError = false
      // 后端 findLatestBcstMsgList 固定只返回最近 1 小时未读广播，1 小时外历史 intentionally 不展示
      findWebBcstMsgList({})
        .then((res) => {
          if (res.code === 200) {
            this.rawNotificationList = res.data.webBcstMsgList || []
            this.total = this.rawNotificationList.length
            if (this.queryInfo.pageNumber > 1 && this.pagedNotificationList.length === 0) {
              this.queryInfo.pageNumber = 1
            }
          } else {
            this.loadError = true
            this.rawNotificationList = []
            this.total = 0
          }
        })
        .catch(() => {
          this.loadError = true
          this.rawNotificationList = []
          this.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize
      this.queryInfo.pageNumber = 1
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNumber = newPage
    }
  }
}
</script>
<style lang="scss" scoped>
.systemNotification {
  display: flex;
  flex-direction: column;
  .notification-list {
    display: flex;
    flex-direction: column;
    .notification-item {
      display: flex;
      flex-direction: column;
      border: 1px solid rgba(121, 121, 121, 1);
      margin-bottom: 15px;

      .title-time {
        display: flex;
        justify-content: space-between;
        background-color: rgba(242, 242, 242, 1);
        height: 40px;
        padding: 0px 15px;
        align-items: center;
        .title {
          font-size: 18px;
        }
        .time {
          font-size: 14px;
        }
      }
      .content {
        margin-top: 5px;
        font-size: 14px;
        padding: 0px 15px;
        line-height: 20px;
        min-height: 60px;
      }
    }
    .empty {
      padding: 40px 0;
      text-align: center;
      color: #909399;
      font-size: 14px;
      &.error {
        color: #f56c6c;
      }
      .empty-hint {
        margin-top: 8px;
        font-size: 12px;
        color: #c0c4cc;
      }
    }
  }
}
</style>
